<template>
    <div id="column" class="mt">
        <a-row style="margin-bottom: 10px">
            <a-button type="primary" @click="asd">Save</a-button>
        </a-row>
        <a-row type="flex" justify="start">
            <a-col :span="3" style="height: 75vh;overflow: hidden;overflow-y: auto">
                <div class="list-group" >
                    <div
                        class="list-group-item"
                        v-for="(element, index) in list1"
                        :key="element.name"
                        @click="listClick"
                    >
                        {{ element.name }}
                    </div>
                </div>
            </a-col>
            <a-col :span="18" style="height: 75vh;overflow: hidden;overflow-y: auto;margin-left: 10px;">
                <a-form :form="form" >
                    <ul style="border: 1px solid #efefef">
                        <li class="editLi">
                            <a-row type="flex" justify="start">
                                <a-col :span="12" class='editLileft'>
                                    <label >Parameter Name</label>
                                </a-col>
                                <a-col :span="12" class="editLiRight">
                                    <a-form-item>
                                        <a-input
                                            disabled
                                            size="small"
                                            style="width: 100%;"
                                            v-decorator="[
                                              'columnName'
                                            ]"/>
                                    </a-form-item>
                                </a-col>
                            </a-row>
                        </li>
                        <li class="editLi">
                            <a-row type="flex" justify="start">
                                <a-col :span="12" class='editLileft'>
                                    <label >Bind Column</label>
                                </a-col>
                                <a-col :span="12" class="editLiRight">
                                    <a-form-item>
                                        <a-select
                                            :placeholder="$t('publicLang.PleaseSelect')"
                                            style="width: 100%"
                                            size="small"
                                            v-decorator="[
                                              'bindColumn'
                                            ]">

                                        </a-select>
                                    </a-form-item>
                                </a-col>
                            </a-row>
                        </li>
                        <li class="editLi">
                            <a-row type="flex" justify="start">
                                <a-col :span="12" class='editLileft'>
                                    <label >Condition</label>
                                </a-col>
                                <a-col :span="12" class="editLiRight">
                                    <a-form-item>
                                        <a-select
                                                :placeholder="$t('publicLang.PleaseSelect')"
                                                size="small"
                                                style="width: 100%"
                                                v-decorator="[
                                                      'condition'
                                                    ]"
                                        ></a-select>
                                    </a-form-item>
                                </a-col>
                            </a-row>
                        </li>
                        <li class="editLi">
                            <a-row type="flex" justify="start">
                                <a-col :span="12" class='editLileft'>
                                    <label >seq</label>
                                </a-col>
                                <a-col :span="12" class="editLiRight">
                                    <a-form-item>
                                        <a-input
                                                :placeholder="$t('publicLang.PleaseEnter')"
                                                size="small"
                                                style="width: 100%;"
                                                v-decorator="[
                                                  'seq'
                                                ]"
                                        />
                                    </a-form-item>
                                </a-col>
                            </a-row>
                        </li>
                        <li class="editLi">
                            <a-row type="flex" justify="start">
                                <a-col :span="12" class='editLileft'>
                                    <label >Default Value</label><span style="color: red;">*</span>
                                </a-col>
                                <a-col :span="12" class="editLiRight">
                                    <a-form-item>
                                        <a-input
                                            :placeholder="$t('publicLang.PleaseEnter')"
                                            size="small"
                                            style="width: 100%;"
                                            v-decorator="[
                                              'defaultValue'
                                            ]"
                                        />
                                    </a-form-item>
                                </a-col>
                            </a-row>
                        </li>
                    </ul>
                </a-form>
            </a-col>
        </a-row>
    </div>
</template>
<script>
    import draggable from "vuedraggable";
    export default{
        components: {
            draggable
        },
        data(){
            return{
                form:  this.$form.createForm(this),
                formItemLayout: {
                    labelCol: {
                        xs: { span: 24 },
                        sm: { span: 8 }
                    },
                    wrapperCol: {
                        xs: { span: 24 },
                        sm: { span: 16 }
                    }
                },
                list1: [
                    { name: "John", id: 1 },
                    { name: "Joao", id: 2 },
                    { name: "Jean", id: 3 },
                    { name: "Gerard", id: 4 }
                ],
            }
        },
        methods:{
            end(val){

            },
            listClick(){
                console.log(1);
            }
        }
    }
</script>
<style>
    #column{
        padding: 0 10px
    }
    .list-group-item{
        text-align: center;
    }
</style>